import React, { useEffect, useState } from "react";
import { api, resolveImageUrl } from "@/lib/api";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

export default function HomeCarousel() {
  const [banners, setBanners] = useState([]);
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/home-banners");
        setBanners(data);
      } catch (e) { /* silent */ }
    })();
  }, []);

  useEffect(() => {
    if (paused || banners.length <= 1) return;
    const t = setInterval(() => setIdx(i => (i + 1) % banners.length), 5000);
    return () => clearInterval(t);
  }, [paused, banners.length]);

  if (banners.length === 0) return null;

  function goto(i) { setIdx(((i % banners.length) + banners.length) % banners.length); }

  return (
    <div
      className="relative rounded-2xl overflow-hidden border border-white/10 mb-10 group"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      data-testid="home-carousel"
    >
      <div className="relative aspect-[16/6] md:aspect-[16/5] bg-[#0a0a0f]">
        <div
          className="flex h-full transition-transform duration-700 ease-out"
          style={{ transform: `translateX(-${idx * 100}%)` }}
        >
          {banners.map((b, i) => {
            const inner = (
              <img
                src={resolveImageUrl(b.image_url)}
                alt=""
                draggable={false}
                className="w-full h-full object-cover flex-shrink-0"
              />
            );
            return (
              <div key={b.home_banner_id} className="w-full h-full flex-shrink-0" data-testid={`carousel-slide-${i}`}>
                {b.link_url ? (
                  <a href={b.link_url} target={b.link_url.startsWith("http") ? "_blank" : "_self"} rel="noopener noreferrer" className="block w-full h-full">
                    {inner}
                  </a>
                ) : inner}
              </div>
            );
          })}
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" />

        {/* Arrows */}
        {banners.length > 1 && (
          <>
            <button
              onClick={() => goto(idx - 1)}
              data-testid="carousel-prev"
              className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/50 backdrop-blur border border-white/10 grid place-items-center text-white opacity-0 group-hover:opacity-100 transition-opacity hover:bg-black/70"
              aria-label="Anterior"
            >
              <CaretLeft size={18} weight="bold" />
            </button>
            <button
              onClick={() => goto(idx + 1)}
              data-testid="carousel-next"
              className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/50 backdrop-blur border border-white/10 grid place-items-center text-white opacity-0 group-hover:opacity-100 transition-opacity hover:bg-black/70"
              aria-label="Seguinte"
            >
              <CaretRight size={18} weight="bold" />
            </button>
          </>
        )}

        {/* Dots */}
        {banners.length > 1 && (
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-2" data-testid="carousel-dots">
            {banners.map((_, i) => (
              <button
                key={i}
                onClick={() => goto(i)}
                data-testid={`carousel-dot-${i}`}
                aria-label={`Ir para banner ${i + 1}`}
                className={`transition-all rounded-full ${i === idx ? "bg-[#E63946] w-8 h-2" : "bg-white/40 hover:bg-white/70 w-2 h-2"}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
